import React, { useEffect, useRef } from 'react';
import './About.scss';

const About = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    // Ekran genişliğini kontrol fonksiyonu
    const isMobile = () => {
      return window.innerWidth <= 768;
    };

    // Accordion ve Swiper yapılandırması
    const setupPanels = () => {
      const panels = document.querySelectorAll('.panel');
      let container = document.querySelector('.accordion-slider-container');
      
      if (!container) return; // Koruyucu kontrol
      
      // Önceki Swiper'ı temizle
      if (swiperRef.current !== null) {
        swiperRef.current.destroy(true, true);
        swiperRef.current = null;
        
        // Container'ı orijinal haline getir
        const originalContainer = document.createElement('div');
        originalContainer.className = 'accordion-slider-container';
        
        // Panel'leri taşı
        const existingPanels = document.querySelectorAll('.panel');
        if (existingPanels && existingPanels.length > 0) {
          Array.from(existingPanels).forEach(panel => {
            originalContainer.appendChild(panel.cloneNode(true));
          });
          
          // Eski container'ı değiştir
          container.parentNode.replaceChild(originalContainer, container);
          container = originalContainer;
        }
      }
      
      // Eğer mobil cihaz ise Swiper'ı aktif et
      if (isMobile()) {
        try {
          // Önce tüm panel'leri kopyala
          const panelsHTML = container.innerHTML;
          
          // Container'ı Swiper yapısına dönüştür
          container.classList.add('swiper');
          container.innerHTML = `<div class="swiper-wrapper"></div>
                              <div class="swiper-pagination"></div>`;
          
          // Panel'leri swiper-slide olarak ekle
          const swiperWrapper = container.querySelector('.swiper-wrapper');
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = panelsHTML;
          const tempPanels = tempDiv.querySelectorAll('.panel');
          
          tempPanels.forEach(panel => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.appendChild(panel.cloneNode(true));
            swiperWrapper.appendChild(slide);
          });
          
          // About section'ı relative konumlandır
          const aboutSection = document.querySelector('.about-section');
          if (aboutSection) {
            aboutSection.style.position = 'relative';
            
            // Custom pagination oluştur
            const customPagination = document.createElement('div');
            customPagination.className = 'swiper-pagination swiper-pagination-external';
            customPagination.style.cssText = `
              position: absolute !important;
              left: 20px !important;
              right: 150px !important;
              bottom: 30px !important;
              display: flex !important;
              align-items: center;
              gap: 0 !important;
              width: auto !important;
            `;
            
            // Custom navigation okları
            const customNavPrev = document.createElement('div');
            customNavPrev.className = 'custom-swiper-button-prev';
            customNavPrev.style.cssText = `
              position: absolute;
              right: 80px;
              bottom: 10px;
              width: 40px;
              height: 40px;
              cursor: pointer;
              background-color: #E1E8E6;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1000;
              transition: background-color 0.3s ease;
            `;
            customNavPrev.innerHTML = '<img src="icons/swiper-left.svg" alt="Previous" style="width:14px; height:14px;">';
            
            const customNavNext = document.createElement('div');
            customNavNext.className = 'custom-swiper-button-next';
            customNavNext.style.cssText = `
              position: absolute;
              right: 20px;
              bottom: 10px;
              width: 40px;
              height: 40px;
              cursor: pointer;
              background-color: #E1E8E6;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1000;
              transition: background-color 0.3s ease;
            `;
            customNavNext.innerHTML = '<img src="icons/swiper-right.svg" alt="Next" style="width:14px; height:14px;">';
            
            // About section'a ekle
            aboutSection.appendChild(customPagination);
            aboutSection.appendChild(customNavPrev);
            aboutSection.appendChild(customNavNext);
            
            // Click event'leri
            customNavPrev.addEventListener('click', () => {
              if (swiperRef.current) swiperRef.current.slidePrev();
            });
            
            customNavNext.addEventListener('click', () => {
              if (swiperRef.current) swiperRef.current.slideNext();
            });
            
            // Hover efektleri
            [customNavPrev, customNavNext].forEach(btn => {
              btn.addEventListener('mouseenter', () => {
                btn.style.backgroundColor = '#283583';
                const img = btn.querySelector('img');
                if (img) img.style.filter = 'brightness(0) invert(1)';
              });
              btn.addEventListener('mouseleave', () => {
                btn.style.backgroundColor = '#E1E8E6';
                const img = btn.querySelector('img');
                if (img) img.style.filter = 'none';
              });
            });
          }
          
          // Swiper başlat (Swiper kütüphanesi varsa)
          if (typeof window.Swiper !== 'undefined') {
            swiperRef.current = new window.Swiper('.swiper', {
              slidesPerView: 1.1,
              spaceBetween: 20,
              centeredSlides: false,
              loop: true,
              speed: 1000,
              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
              },
              pagination: {
                el: '.swiper-pagination-external',
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
                renderBullet: function (index, className) {
                  return '<span class="' + className + '" style="flex: 1; height: 3px; border-radius: 0; margin: 0; opacity: 0.3; background-color: #004481; cursor: pointer; transition: opacity 0.3s ease;"></span>';
                }
              },
              breakpoints: {
                576: {
                  slidesPerView: 1.5,
                  spaceBetween: 20
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                  centeredSlides: false
                }
              }
            });
            
            // Active bullet style - Daha güçlü CSS
            const style = document.createElement('style');
            style.textContent = `
              .swiper-pagination-external .swiper-pagination-bullet-active {
                opacity: 1 !important;
                background-color: #004481 !important;
                background: #004481 !important;
              }
              .swiper-pagination-external .swiper-pagination-bullet {
                opacity: 0.2 !important;
                background-color: #004481 !important;
                background: #004481 !important;
              }
            `;
            document.head.appendChild(style);
            
            // Pagination event'i dinle ve manuel style uygula
            setTimeout(() => {
              const bullets = document.querySelectorAll('.swiper-pagination-bullet');
              bullets.forEach((bullet, index) => {
                bullet.style.backgroundColor = '#004481';
                bullet.style.opacity = '0.2';
                
                bullet.addEventListener('click', () => {
                  bullets.forEach(b => {
                    b.style.opacity = '0.2';
                  });
                  bullet.style.opacity = '1';
                });
              });
              
              // İlk bullet'ı aktif yap
              if (bullets[0]) {
                bullets[0].style.opacity = '1';
              }
            }, 100);
            
          } else {
            console.error('Swiper kütüphanesi yüklenemedi!');
          }
        } catch (e) {
          console.error('Swiper yapılandırılırken hata:', e);
        }
      } else {
        // Desktop için accordion davranışı
        panels.forEach(panel => {
          const handlePanelClick = function() {
            // Tıklanan panel zaten aktifse, hiçbir şey yapma
            if (this.classList.contains('active')) { 
              return;
            }
            
            // Tüm panelleri kapat
            panels.forEach(p => p.classList.remove('active'));
            
            // Tıklanan paneli aç
            setTimeout(() => {
              this.classList.add('active');
              
              // İçeriklerin fade-in animasyonu
              const h3 = this.querySelector('h3');
              const panelText = this.querySelector('.panel-text');
              
              if (h3) {
                h3.style.opacity = '0';
                h3.style.transform = 'translateY(10px)';
                setTimeout(() => {
                  h3.style.opacity = '1';
                  h3.style.transform = 'translateY(0)';
                }, 200);
              }
              
              if (panelText) {
                panelText.style.opacity = '0';
                panelText.style.transform = 'translateY(10px)';
                setTimeout(() => {
                  panelText.style.opacity = '1';
                  panelText.style.transform = 'translateY(0)';
                }, 300);
              }
            }, 50);
          };
          
          panel.addEventListener('click', handlePanelClick);
        });
        
        // İlk paneli her zaman aktif et
        if (panels.length > 0) {
          panels.forEach(p => p.classList.remove('active'));
          panels[0].classList.add('active');
        }
      }
    };

    // İlk kurulum
    setupPanels();

    // Resize event'i için throttle
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setupPanels, 100);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup function
    return () => {
      if (swiperRef.current) {
        swiperRef.current.destroy(true, true);
        swiperRef.current = null;
      }
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section className="about-section" data-aos="fade-up" data-aos-delay="300" id="bizkimiz">
      <div className="container">
        <h2 className="section-title">Biz Kimiz</h2>
        <p className="section-paragraph">Hayat Fintek'i Tanıyın!</p>
        
        <div className="accordion-slider-container">
          {/* Panel 1: İnovasyon */}
          <div className="panel">
            <div className="panel-image">
              <img src="images/about-1.jpg" alt="İnovasyon" />
            </div>
            <div className="panel-content">
              <div className="content-wrapper">
                <h3>Finansal Teknolojiler Sektörüne Yeni Bir Soluk Getirdik</h3>
                <div className="panel-text">
                  <p>2024 yılı Mart ayında, Türkiye'nin ilk dijital bankası Hayat Finans'ın %100 iştiraki olarak kurularak finansal teknolojiler alanında fark yaratmak için yola çıktık. Dijital bankacılık, teknoloji ve inovasyonu bir araya getirerek teknoloji dünyasının ihtiyaçlarına özel çözümler geliştiriyoruz.</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Panel 2 */}
          <div className="panel">
            <div className="panel-image">
              <img src="images/about-2.jpg" alt="Teknoloji" />
            </div>
            <div className="panel-content">
              <div className="content-wrapper">
                <h3>Gücümüzü Hayat Holding'in 88 Yıllık Birikiminden Alıyoruz</h3>
                <div className="panel-text">
                  <p>Hayat Holding'in 88 yıllık köklü tecrübesinden aldığımız güçle, sürekli gelişimi ilke edinerek finansal teknolojileri yalnızca bir araç değil, bireylerin hayatına değer katan, kullanıcı deneyimini odağa alan ve kişiselleştirilmiş hizmetler sunan stratejik bir amaç olarak benimsiyoruz</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Panel 3 */}
          <div className="panel">
            <div className="panel-image">
              <img src="images/about-3.jpg" alt="Çözümler" />
            </div>
            <div className="panel-content">
              <div className="content-wrapper">
                <h3>Fintek Gücümüzle Ekosistemleri Dönüştürüyoruz</h3>
                <div className="panel-text">
                  <p>Dijital bankacılıktan perakende sektörüne kadar geniş bir yelpazede hizmet sunuyor; kullanıcı deneyimini ve kişiselleştirmeyi odağımıza alarak, iş ortaklarımıza ve müşterilerimize yenilikçi ürünler sunuyoruz. Fintek dünyasına yön vermeyi hedefliyoruz.</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Panel 4 */}
          <div className="panel">
            <div className="panel-image">
              <img src="images/about-4.jpg" alt="Ekip" />
            </div>
            <div className="panel-content">
              <div className="content-wrapper">
                <h3>Stratejik Vizyonla Geleceği Şekillendiriyoruz</h3>
                <div className="panel-text">
                  <p>Hayat Fintek olarak amacımız, yalnızca bugünün ihtiyaçlarına yanıt vermek değil; dijital finansın geleceğini bugünden inşa etmektir. Yaygın erişim, ölçeklenebilir dijital hizmetler ve yenilikçi iş modelleriyle, bireylerin ve kurumların hayatına gerçek değer katmayı hedefliyoruz.</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Panel 5 */}
          <div className="panel">
            <div className="panel-image">
              <img src="images/about-5.jpg" alt="Gelecek" />
            </div>
            <div className="panel-content">
              <div className="content-wrapper">
                <h3>Teknolojiyi İnsan Odaklı Kullanıyoruz</h3>
                <div className="panel-text">
                  <p>Yapay zeka, pazarlama analitiği gibi çözümlerimizle; kullanıcılarımızın ihtiyaçlarına birebir yanıt veren, kişiselleştirilmiş modeller geliştiriyoruz.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 